<template>
  <div class="text--secondary">
    <span class="dot"></span>
      обновлено
    <span class="time">{{ updTimestamp | unixtimeToCalendar }}</span>
  </div>
</template>

<script>
import json from "/public/info.json"
import moment from "moment"
moment.locale("ru")

export default {
  name: "UpdateStatus",
  data() {
    return {
      updTimestamp: json.timestamp
    }
  },
  filters: {
    unixtimeToCalendar: function (value) {
      if (value) {
        return moment.unix(value).calendar()
      }
    }
  }
}
</script>

<style scoped>
.dot {
  height: 15px;
  width: 15px;
  margin: 2px;
  margin-bottom: 4px;
  background-color: limegreen;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
}
.time {
  text-transform: lowercase;
}
</style>
